import type { AxiosResponse } from "axios";

import { AxiosInstance } from "api";

export const deleteUsTherapistLicense = async (id: number): Promise<AxiosResponse> =>
  AxiosInstance.delete(`/us_therapist_licenses/${id}`);
